module.exports = __webpack_public_path__ + "img/shipo-menu-plan.8981e4fb.svg";